import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  ROUTES,
  EMPTY_STRING,
  customerConstants,
} from "../../../../../constants";
import { Images } from "../../../../../assets/images";
import {
  convertDateToUTC,
  convertEpochTo12HourTime,
  isKeepCustomerDashboardCart,
} from "../../../../../shared";
import { NavigateToPath } from "../../../../../system";
import EventDetailRow from "../../../../../shared/components/Events/EventDetailRow";
import EventActionCard from "../../../../../shared/components/Events/EventActionCard";
import ConfirmationModal from "../../../../../shared/components/Modal/ConfirmationModal";

const EventDetail = ({
  event,
  eventGroupId,
  activeTab,
  handleEventCancelation,
  customerDashboardCart,
  isGroupEvent = false,
  remainingUpcomingEvent = 0,
}) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [path, setPath] = useState(EMPTY_STRING);

  const RedirectToPath = (pathToGo) => {
    NavigateToPath(
      history,
      `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${pathToGo}`
    );
  };

  const handleTipExtend = (event, pathToGo) => {
    const isSameEvent = isKeepCustomerDashboardCart(
      customerDashboardCart,
      event?.orderId
    );
    if (isSameEvent) {
      RedirectToPath(pathToGo);
    } else {
      setPath(pathToGo);
      setShowModal(true);
    }
  };

  const ianaTimezone = event?.eventLocation?.[0]?.timezone;

  return (
    <>
      <div>
        <EventDetailRow
          label="shutterb:"
          value={event?.sbusers
            ?.filter((u) => u != null) // Optional null check
            .map((u) => {
              const fullName = `${u.firstName} ${u.lastName}`.trim();
              return fullName ? (u.isRejected ? `${fullName} - rejected` : fullName) : null;
            })
            .filter((name) => name) // Avoid null or empty
            .join(", ")}
        />
        <EventDetailRow label="event type:" value={event?.eventType?.name} />
        <EventDetailRow
          label="event date:"
          value={convertDateToUTC(event?.eventDate, ianaTimezone)}
        />
        <EventDetailRow
          label="event duration:"
          value={`${event?.duration} ${
            event?.duration <= 1 ? " hour" : " hours"
          }`}
        />
        <EventDetailRow
          label="event start time:"
          value={convertEpochTo12HourTime(event?.eventStartTime, ianaTimezone)}
        />
        <EventDetailRow
          label="shutterb start time:"
          value={convertEpochTo12HourTime(event?.sbStartTime, ianaTimezone)}
        />
        <EventDetailRow
          label="address"
          value={event?.eventLocation[0]?.currentLocation}
        />

        <div className="d-flex flex-wrap py-2">
          {!isGroupEvent && (
            <EventActionCard
              to={`${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${customerConstants.DOWNLOAD_INVOICE}`}
              iconSrc={Images.Invoice}
              iconAlt="invoice-icon"
              title="invoice"
              description="access your event invoice and billing information."
            />
          )}
          <EventActionCard
            iconSrc={Images.Clock}
            iconAlt="shutterb-extension-icon"
            title="extend your shutterb"
            description="event running over? no problem. extend your shutterb here."
            isDisabled={
              activeTab === customerConstants.CANCELLED_EVENTS ||
              activeTab === customerConstants.COMPLETED_EVENTS
            }
            disabledIcon={Images.ClockDisabled}
            disabledAlt="extend your shutterb disabled icon"
            onClick={() => {
              handleTipExtend(event, customerConstants.EXTEND_YOUR_SHUTTERB);
            }}
          />

          <EventActionCard
            iconSrc={Images.Tip}
            iconAlt="Tip Shutterb Icon"
            title="tip your shutterb"
            description="show some love to your shutterb by tipping them for a job well done."
            isDisabled={activeTab === customerConstants.CANCELLED_EVENTS}
            disabledIcon={Images.TipDisabled}
            disabledAlt="Tip Your ShutterB Disabled Icon"
            onClick={() => {
              handleTipExtend(event, customerConstants.TIP_YOUR_SHUTTERB);
            }}
          />

          <EventActionCard
            to={`${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${customerConstants.ACCESS_GALLERY}`}
            iconSrc={Images.Gallery}
            iconAlt="Gallery Icon"
            title="gallery"
            description="click here to access your images, share, download and print."
          />

          <EventActionCard
            to={`${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${customerConstants.REVIEW_YOUR_SHUTTERB}`}
            iconSrc={Images.Review}
            iconAlt="Review Icon"
            title="review your shutterb"
            description="how did your shutterb do? we'd love to hear what you think!"
          />

          {activeTab === customerConstants.COMPLETED_EVENTS &&
            event.isReelExist && (
              <EventActionCard
                to={`${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${customerConstants.RECAP_FEEDBACK}`}
                iconSrc={Images.RecapFeedback}
                iconAlt="Recap-Feedback"
                title="recap feedback"
                description="submit a feedback to the recap added for your event."
              />
            )}

          <EventActionCard
            to={
              activeTab !== customerConstants.CANCELLED_EVENTS &&
              `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}/${eventGroupId}/${event.id}/${customerConstants.MESSAGE_BOARD}`
            }
            iconSrc={Images.Message}
            iconAlt="Message Icon"
            disabledIcon={Images.MessageDisabled}
            disabledAlt="Message Disabled Icon"
            isDisabled={activeTab === customerConstants.CANCELLED_EVENTS}
            title="message board"
            description="message your shutterb(z). share your thoughs & discuss about your event."
          />

          {/* {activeTab === customerConstants.UPCOMING_EVENTS &&
            event?.isEditEventAllowed && (
              <EventActionCard
                to={`${ROUTES.EVENT_BOOKING}/${eventBookingParams.EDIT_EVENT}/${event.eventGroupId}/${event.id}`}
                iconSrc={Images.EditEvent}
                iconAlt="edit-event-icon"
                title="edit event"
                description="edit your event details by going through the booking form again."
              />
            )} */}

          {activeTab === customerConstants.UPCOMING_EVENTS && (
            <EventActionCard
              iconSrc={Images.CancelEvent}
              iconAlt="Cancel Event Icon"
              disabledIcon={Images.CancelEventDisabled}
              disabledAlt="Cancel Event Disabled Icon"
              isDisabled={
                activeTab !== customerConstants.UPCOMING_EVENTS ||
                !event.isCancelEventAllowed
              }
              onClick={
                activeTab === customerConstants.UPCOMING_EVENTS &&
                event.isCancelEventAllowed &&
                (() => {                  
                  remainingUpcomingEvent > 1
                    ? handleEventCancelation(event.eventGroupId, event.id)
                    : handleEventCancelation(event.eventGroupId);
                })
              }
              title="cancel event"
              description="cancel your event."
            />
          )}
        </div>
      </div>

      <ConfirmationModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => {
          setShowModal(false);
          RedirectToPath(path);
        }}
        dialogText="confirm_switch_event_cart_clear"
        maxWidth="xs"
        buttonText={"proceed"}
      />
    </>
  );
};

export default EventDetail;
